// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"b97aec96","389":"c852f3d5","571":"da5b3cc0"}[chunkId] + ".chunk.js";
};